module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-mv-image-3-a39333ab816b472790e41f3445389917.png";